import { useCallback } from 'react';

import { RADIUS_PRESETS_KM } from '../../../config/geo';

// Snap value to the closest preset when within 3km, otherwise keep raw.
const snap = (v) => {
  const found = RADIUS_PRESETS_KM.find((p) => Math.abs(p - v) <= 3);
  return found ?? v;
};

// RadiusControl — combined numeric input + range slider that snaps to
// preset radii. Emits changes as numbers (km).
export const RadiusControl = ({ value, onChange, min = 1, max = 250 }) => {
  const handleSlider = useCallback(
    (e) => onChange(snap(Number(e.target.value))),
    [onChange]
  );

  const handleInput = useCallback(
    (e) => {
      const n = Number(e.target.value);
      if (Number.isFinite(n)) onChange(Math.max(min, Math.min(max, n)));
    },
    [onChange, min, max]
  );

  return (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex items-center gap-3">
        <label
          htmlFor="import-radius-input"
          data-testid="scope-anchor-label"
          className="text-sm font-medium text-blackColor"
        >
          Search radius from Nice
        </label>
        <div className="flex items-center gap-1">
          <input
            id="import-radius-input"
            data-testid="scope-radius-input"
            type="number"
            min={min}
            max={max}
            value={value}
            onChange={handleInput}
            aria-label="Radius in kilometres"
            className="w-20 px-2 py-1 text-sm border border-gray-200 rounded outline-none focus:border-purpleColor text-right"
          />
          <span className="text-xs text-darkGrayColor">km</span>
        </div>
      </div>

      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={handleSlider}
        aria-label="Radius slider"
        className="w-full accent-purpleColor cursor-pointer"
      />

      <div className="flex items-center gap-2 flex-wrap">
        {RADIUS_PRESETS_KM.map((p) => {
          const isActive = p === value;
          return (
            <button
              key={p}
              type="button"
              data-testid={`scope-histogram-bucket-${p}`}
              onClick={() => onChange(p)}
              className={
                'px-2.5 py-1 text-xs rounded border transition-all ' +
                (isActive
                  ? 'border-purpleColor bg-purpleColor text-white shadow-sm'
                  : 'border-gray-200 text-darkGrayColor hover:border-purpleColor hover:text-purpleColor')
              }
            >
              {p} km
            </button>
          );
        })}
      </div>
    </div>
  );
};
